import { render, staticRenderFns } from "./academy_about.vue?vue&type=template&id=cfb06ac8&"
import script from "./academy_about.vue?vue&type=script&lang=js&"
export * from "./academy_about.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {HeaderDefault: require('/home/smiley/3df/components/Header/HeaderDefault/HeaderDefault.vue').default,BlockContent: require('/home/smiley/3df/components/Block/BlockContent/BlockContent.vue').default,BannerWhite: require('/home/smiley/3df/components/Banner/BannerWhite/BannerWhite.vue').default,BannerSeal: require('/home/smiley/3df/components/Banner/BannerSeal/BannerSeal.vue').default,AcademySectionRegister: require('/home/smiley/3df/components/AcademySectionRegister/AcademySectionRegister.vue').default})
